import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@sparebankenvest/splash-ui';
import HeartIcon from './HeartIcon';
import PhoneIcon from './PhoneIcon';
import GAEvent from '../utils/ga';

const WrapperContact = styled.div`
  display: flex;
  align-items: stretch;
  margin: 20px -6px 0;
  section {
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 6px;
    width: 50%;
    padding: 20px 20px 30px;
  }
  svg {
    width: 56px;
    height: 56px;
    fill: #B42418;
  }
  h2 {
    font-size: 30px;
    line-height: 32px;
    margin: 10px 0;
    text-align: center;
    color: #6C6C6C;
  }
  p {
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #444444;
    padding: 0 8px;
  }
  ${Button} {
    width: 100%;
    max-width: 174px;
  }
  @media (max-width: 400px) {
    ${Button} {
      padding-left: 0;
      padding-right: 0;
    }
  }
  @media (max-width: 600px) {
    flex-direction: column;
    section {
      width: 100%;
      margin: 4px 0;
      align-items: flex-start;
      justify-items: center;
      padding-left: 64px;
      padding: 20px 20px 20px 68px;
    }
    p {
      text-align: left;
      padding: 0;
    }
    h2 {
      font-size: 24px;
      line-height: 28px;
      text-align: left;
      margin: 0 0 8px;
    }
    svg {
      width: 40px;
      height: 40px;
      position: absolute;
      transform: translateX(-52px);
    }
  }
`;


const Hr = styled.hr`
  height: 1px;
  width: 100%;
  margin: 24px 0;
  background: #BBBBBB;
  border: 0;
`;

const Heading = styled.h1`
  font-size: 24px;
  line-height: 32px;
  color: #444;
`;

const KontaktOss = ({
  title,
  text,
  noContact,
}) => {
  return (
    <section>
      <Hr />
      <Heading>{title}</Heading>
      {text && <p>{text}</p>}
      {!noContact && (
        <WrapperContact>
          <section>
            <HeartIcon />
            <div>
              <h2>
                Vi hjelper deg med Seniorlån
              </h2>
              <p>Avtale et møte i banken eller på telefon</p>
            </div>
            <Button
              component="a"
              href="https://www2.spv.no/motebooking/app/un"
              target="_blank"
              onClick={() => {
                GAEvent({
                  action: 'Bestill møte',
                  data: {},
                })
              }}
            >
              Bestill møte
            </Button>
          </section>
          <section>
            <PhoneIcon />
            <div>
              <h2>
                Ring oss
              </h2>
              <p>Telefonen er åpen alle dager fra 09-23</p>
            </div>
            <Button
              variant="navigation"
              component="a"
              href="tel:91505555"
              target="_blank"
              onClick={() => {
                GAEvent({
                  action: 'Ring oss',
                  data: {},
                })
              }}
            >
              Ring 915 05555
            </Button>
          </section>
        </WrapperContact>
      )}
    </section>
  );
};

KontaktOss.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  noContact: PropTypes.bool.isRequired,
};

KontaktOss.defaultProps = {
  noContact: false,
};

export default KontaktOss;